import { createApiSlice } from 'app/createApiSlice'
import {
  API_SCHEMA,
  API_SCHEMA_ADD,
  API_SESSION,
  API_SESSION_STOP,
} from 'utils/apiList'

export const processApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'process/hooks',
  endpoints(builder) {
    return {
      fetchSession: builder.query({
        query(params) {
          return {
            url: API_SESSION,
            params,
          }
        },
      }),
      addEditSession: builder.mutation({
        query(payload) {
          return {
            url: API_SESSION,
            method: 'POST',
            body: payload,
          }
        },
      }),
      stopSession: builder.mutation({
        query(payload) {
          return {
            url: API_SESSION_STOP,
            method: 'POST',
            body: payload,
          }
        },
      }),
      fetchSchema: builder.query({
        query(params) {
          return {
            url: API_SCHEMA,
            params,
          }
        },
      }),
      fetchSchemaDetail: builder.query({
        query(params) {
          return {
            url: `${API_SCHEMA}/${params?.id}`,
            // params,
          }
        },
      }),
      addSchema: builder.mutation({
        query(payload) {
          return {
            url: API_SCHEMA_ADD,
            method: 'POST',
            body: payload,
          }
        },
      }),
    }
  },
})

export const {
  useFetchSessionQuery,
  useFetchSchemaQuery,
  useFetchSchemaDetailQuery,
  useLazyFetchSessionQuery,
  useAddEditSessionMutation,
  useStopSessionMutation,
  useAddSchemaMutation,
} = processApiSlice
